<template>
    <div>
        <!--admin  mobile -->
        <div class="admin-profile__desktop-mobile">
            <a class="desktop-wrapper" dusk="'link-home'" :href="userSectionPrefix + '/'">
                <svg width="20" height="20">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-admin"></use>
                </svg>
                <a class='nav__auth-link nav__auth-link--admin' dusk="'link-home'" :href="userSectionPrefix + '/'">
                    Рабочий стол
                </a>
            </a>
            <div v-for="section in sections">
                <div @click="openSection(section)" class="nav__auth-wrapper-mobile">
                    {{ section.name }}
                    <svg v-if="section.active" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-caret-up"></use>
                    </svg>
                    <svg v-else width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                    </svg>
                </div>
                <div v-if="section.active" class="nav__auth-wrapper">
                    <div v-for="page in section.pages">
                        <a v-if="page.roles.includes(userRoleName)"
                           :href="userSectionPrefix + page.href"
                           :dusk="page.dusk"
                           class="nav__admin-link"
                        >
                            {{ page.name }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--        admin  desktop -->
        <div class="admin-profile__desktop">
            <a class="desktop-wrapper" dusk="'link-home'" :href="userSectionPrefix + '/'">
                <svg width="20" height="20">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-admin"></use>
                </svg>
                <a class='nav__auth-link nav__auth-link--admin' dusk="'link-home'" :href="userSectionPrefix + '/'">
                    Рабочий стол
                </a>
            </a>

            <div v-for="section in sections">
                <div class="nav__auth-wrapper">
                    <h2 class="nav__auth-wrapper-title">{{ section.name }}</h2>
                    <div v-for="page in section.pages">
                        <a v-if="page.roles.includes(userRoleName)"
                           :href="userSectionPrefix + page.href"
                           :dusk="page.dusk"
                           class="nav__admin-link"
                        >
                            {{ page.name }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import HeaderDesktopButton from "./HeaderDesktopButton.vue";
import HeaderLogoutButton from "./HeaderLogoutButton.vue";
import Vue from "vue";
import {mapState} from "vuex";

export default {
    name: "AdminSections",
    components: {
        HeaderDesktopButton,
        HeaderLogoutButton
    },
    data() {
        return {
            user: window.laravel.user,
            prefix: window.laravel.prefix,
            isPartner: window.laravel.isPartner,
            sections: [
                {
                    name: "Основное",
                    active: false,
                    pages: [
                        {
                            name: Vue.prototype.$lang('userMenu.title27'),
                            href: '/pages',
                            roles: ['admin', 'partner', 'master'],
                            dusk: 'link-pages',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title7'),
                            href: '/pages/related',
                            roles: ['admin', 'partner', 'master'],
                            dusk: 'link-burial',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title3'),
                            href: '/partners',
                            roles: ['admin'],
                            dusk: 'link-partners',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title4'),
                            href: '/masters',
                            roles: ['admin', 'partner'],
                            dusk: 'link-masters',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title5'),
                            href: '/responsibles',
                            roles: ['admin', 'partner', 'master'],
                            dusk: 'link-responsibles',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title9'),
                            href: '/locations',
                            roles: ['admin'],
                            dusk: 'link-locations',
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title19'),
                            href: '/places',
                            roles: ['admin', 'partner', 'master'],
                            dusk: 'link-places',
                            group: 'Основное'
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title25'),
                            href:  '/trees',
                            roles: ['admin'],
                            group: 'Основное'
                        },
                    ]
                },
                {
                    name: "СМИ",
                    active: false,
                    pages: [
                        {
                            name: Vue.prototype.$lang('userMenu.title8'),
                            href: '/news',
                            roles: ['admin'],
                            dusk: 'link-news',
                            group: "СМИ"
                        },
                        {
                            name: Vue.prototype.$lang('app.menu.articles'),
                            href: '/articles',
                            roles: ['admin'],
                            dusk: 'link-articles',
                            group: "СМИ"
                        },
                    ]
                },
                {
                    name: "Технические настройки",
                    active: false,
                    pages: [
                        {
                            name: Vue.prototype.$lang('userMenu.title20'),
                            href: '/prices',
                            roles: ['admin'],
                            dusk: 'link-prices',
                            group: "Технические настройки"
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title21'),
                            href: '/langs',
                            roles: ['admin'],
                            dusk: 'link-langs',
                            group: "Технические настройки"
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title24'),
                            href: '/promo-codes',
                            roles: ['admin'],
                            dusk: 'link-promo-codes',
                            group: "Технические настройки"
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title26'),
                            href: '/qr-codes',
                            roles: ['admin'],
                            dusk: 'link-promo-codes',
                            group: "Технические настройки"
                        },
                        {
                            name: Vue.prototype.$lang('userMenu.title28'),
                            href: '/promo-subscriptions',
                            roles: ['admin'],
                            dusk: 'link-subscriptions',
                            group: "Технические настройки"
                        }
                    ]
                }
            ]
        }
    },
    computed: {
        ...mapState('header', [
            'headerPagesHtml'
        ]),
        memoriesPageLink() {
            return this.user.profile
                ? window.laravel.prefix + '/memories/' + this.user.profile.slug
                : window.laravel.prefix + '/memories/edit';
        },
        profileRouteName() {
            return this.isPartner ? 'profile-partner' : 'profile-user';
        },
        userRoleName() {
            return this.user ? this.user.roles[0].title : null;
        },
        userSectionPrefix() {
            return this.prefix + '/cabinet';
        },
    },
    methods: {
        openSection(section) {
            if (section.active) {
                this.sections.forEach(s => s.active = false);
            } else {
                this.sections.forEach(s => s.active = s === section);
            }
        }
    }
}
</script>
